import en from "./en-CA";
import fr from "./fr-CA";

const components = {
  ...en,
  ...fr,
};
export default components;
